import React from "react";
import { Link } from "react-router-dom";
import "../App.css";
import predioEniato from '../assets/edificio-shammas.png'

/**
 * Seção genérica "imagem + texto" — usada na Home (About, imagem à
 * esquerda) e em Sobre (Trajetória, imagem à direita via `reverse`).
 *
 * Props:
 * - eyebrow: string (opcional)
 * - title: string
 * - paragraphs: string[]
 * - button: { label, to } (opcional)
 * - imageSrc, imageAlt: usados quando o lado ilustrado é uma foto
 * - media: ReactNode (opcional) — quando informado, substitui a foto por
 *   um elemento gráfico (ex.: uma ilustração em SVG)
 * - reverse: boolean — inverte a posição (texto à esquerda, imagem à direita)
 */
export default function MediaTextSection({
  eyebrow,
  title,
  paragraphs = [],
  button,
  imageSrc,
  imageAlt,
  media,
  reverse = false,
}) {
  return (
    <section className={"media-text" + (reverse ? " media-text--reverse" : "")}>
      <div className="media-text__container">
        <div className="media-text__media">
          {media ? (
            <div className="media-text__visual">{media}</div>
          ) : (
            <img src={predioEniato} alt={imageAlt} className="media-text__image" />
          )}
        </div>

        <div className="media-text__content">
          {eyebrow && <span className="media-text__eyebrow">{eyebrow}</span>}
          <h2 className="media-text__title">{title}</h2>

          {paragraphs.map((paragraph, index) => (
            <p key={index} className="media-text__text">
              {paragraph}
            </p>
          ))}

          {button && (
            <Link to={button.to} className="media-text__button">
              {button.label}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
